import { render } from "./ProductBundles.vue?vue&type=template&id=34d7ac65&scoped=true"
import script from "./ProductBundles.vue?vue&type=script&lang=js"
export * from "./ProductBundles.vue?vue&type=script&lang=js"

import "./ProductBundles.vue?vue&type=style&index=0&id=34d7ac65&scoped=true&lang=css"
import "./ProductBundles.vue?vue&type=style&index=1&id=34d7ac65&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d7ac65"]])

export default __exports__